export const HOME = {
  href: '/isuzu-trusted-buddy',
  label: 'ISUZU <span>TRUSTED BUDDY</span>',
};
export const ABOUT_HISTORY = {
  href: '/isuzu-trusted-buddy/about-history',
  label: '6 ทศวรรษแห่งความผูกพัน',
};
export const RESTOMOD_TFR = {
  href: '/isuzu-trusted-buddy/restomod-tfr',
  label: 'การกลับมาของปิกอัพในตำนาน',
};
export const DEALER_STORY = {
  href: '/isuzu-trusted-buddy/dealer-story',
  label: 'เคียงข้างคนไทย…ทุกการเดินทาง',
};
export const BUILD_YOUR_CAR = {
  href: '/isuzu-trusted-buddy/build-your-car',
  label: 'เปลี่ยนรถของคุณให้เป็นตำนาน',
};

export const NAV_ITEMS = [
  {
    ...HOME,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc1b899617e231338/6811e81c5f67264f28bf92c4/menu-trusted-buddy.jpg',
      alt: HOME.label,
    },
  },
  {
    ...ABOUT_HISTORY,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltcd893d797e307f72/6811e81ca61e013700da9161/menu-about-history.jpg',
      alt: ABOUT_HISTORY.label,
    },
  },
  {
    ...RESTOMOD_TFR,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4d91137c7b64d1b2/6811e81c779714079565eb56/menu-restomod-tfr.jpg',
      alt: RESTOMOD_TFR.label,
    },
  },
  {
    ...DEALER_STORY,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2c77d156ebea3151/6811e81c8638c9f39cff32f6/menu-dealers.jpg',
      alt: DEALER_STORY.label,
    },
  },
  {
    ...BUILD_YOUR_CAR,
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt185ce9ec7507b892/6811e81c2544502c505361bb/menu-build-your-car.jpg',
      alt: BUILD_YOUR_CAR.label,
    },
  },
];
